import { GetterTree } from 'vuex';
import { State } from '@/core/store/auth/state';
import { ProfileInterface, UserPermissions } from '@/shared/interfaces/profile.interface';

export interface Getters {
    isAuthenticated: boolean;
    authStatus: string;
    getProfile: ProfileInterface;
    getPermissions: UserPermissions
}

export const getters: GetterTree<State, any> = {
    isAuthenticated: (state) => !!state.token,
    authStatus: (state) => state.status,
    getProfile: (state) => state.profile,
    getPermissions: (state) => state.userPermissions
};
